import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import GuidaPage from "@/pages/guida/page";
import SicurezzaPage from "@/pages/sicurezza/page";
import ProdottiMiglioriPage from "@/pages/prodotti-migliori/page";
import ComeFunzionaPage from "@/pages/come-funziona/page";
import RecensioniPage from "@/pages/recensioni/page";
import TutorialPage from "@/pages/tutorial/page";
import ConfrontoPage from "@/pages/confronto/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/guida-itaobuy-spreadsheet",
    element: <GuidaPage />,
  },
  {
    path: "/sicurezza-itaobuy-spreadsheet",
    element: <SicurezzaPage />,
  },
  {
    path: "/prodotti-migliori-itaobuy",
    element: <ProdottiMiglioriPage />,
  },
  {
    path: "/come-funziona-itaobuy-spreadsheet",
    element: <ComeFunzionaPage />,
  },
  {
    path: "/recensioni-itaobuy-spreadsheet",
    element: <RecensioniPage />,
  },
  {
    path: "/tutorial-itaobuy-spreadsheet",
    element: <TutorialPage />,
  },
  {
    path: "/confronto-itaobuy-spreadsheet",
    element: <ConfrontoPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;